import { Entity } from "../helpers/Entity"

type PaymentIntentAttributes = {
    accountId: string
    createdAt: Date
    externalId: string
    paymentProcessorKey: string
    paymentMethodType: string
    savePaymentMethodOnFile: boolean
}

export type PaymentIntentDto = {
    id: string
    type: string
    attributes: PaymentIntentAttributes,
}

export class PaymentIntent implements Entity {
    dto: PaymentIntentDto

    constructor(dto: PaymentIntentDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return !!this.dto
    }

    getId(): string {
        return this.dto.id
    }
}


// WEBPACK FOOTER //
// ./src/state/payment-intent/PaymentIntent.ts